import request from '@/utils/request'

// 查询文本提示列表
export function listTransfer(query) {
  return request({
    url: '/ywpx/transfer/list',
    method: 'get',
    params: query
  })
}

// 查询文本提示详细
export function getTransfer(id) {
  return request({
    url: '/ywpx/transfer/' + id,
    method: 'get'
  })
}

// 新增文本提示
export function addTransfer(data) {
  return request({
    url: '/ywpx/transfer',
    method: 'post',
    data: data
  })
}

// 修改文本提示
export function updateTransfer(data) {
  return request({
    url: '/ywpx/transfer',
    method: 'put',
    data: data
  })
}

// 删除文本提示
export function delTransfer(id) {
  return request({
    url: '/ywpx/transfer/' + id,
    method: 'delete'
  })
}
